import { TwitterIcon } from 'react-share'
import { Accept } from './Accept'
import { AddCircle } from './AddCircle'
import { AddPerson } from './AddPerson'
import { ArrowBack } from './ArrowBack'
import { ArrowBackIcon } from './ArrowBackIcon'
import { ArrowBackNoBg } from './ArrowBackNoBg'
import { ArrowDropdown } from './ArrowDropdown'
import { ArrowForward } from './ArrowForward'
import { ArrowLeft } from './ArrowLeft'
import { ArrowRightLine } from './ArrowRightLine'
import { ArrowUp } from './ArrowUp'
import { AutoGraph } from './AutoGraph'
import { Bell } from './Bell'
import { BlogIcon } from './BlogIcon'
import { Calendar } from './Calendar'
import { Cancel } from './Cancel'
import { CenterFocusStrong } from './CenterFocusStrong'
import { ChatIcon } from './ChatIcon'
import { CheckAll } from './CheckAll'
import { CheckCircle } from './CheckCircle'
import { Checkmark } from './Checkmark'
import { ChevronLeft } from './ChevronLeft'
import { ChevronRight } from './ChevronRight'
import { Clock } from './Clock'
import { Close } from './Close'
import { Comment } from './Comment'
import { CommentOutline } from './CommentOutline'
import { Copy } from './Copy'
import { CropFree } from './CropFree'
import { DefaultAvatar } from './DefaultAvatar'
import { Delete } from './Delete'
import { DownChevron } from './DownChevron'
import { Edit } from './Edit'
import { Email } from './Email'
import { EmailIcon } from './EmailIcon'
import { EmojiEvent } from './EmojiEvent'
import { EmojiEventNotify } from './EmojiEventNotify'
import { EmptyCircle } from './EmptyCircle'
import { ErrorRoundedIcon } from './ErrorRoundedIcon'
import { Event } from './Event'
import { EventOutline } from './EventOutline'
import { EventsIconRounded } from './EventsIconRounded'
import { ExpandMore } from './ExpandMore'
import { Facebook } from './Facebook'
import { Favorite } from './Favorite'
import { FileDownload } from './FileDownload'
import { FileUpload } from './FileUpload'
import { Filter } from './Filter'
import { FilterNoBg } from './FilterNoBg'
import { Group } from './Group'
import { GroupOutline } from './GroupOutline'
import { Help } from './HelpIcon'
import { HelpOutline } from './HelpOutline'
import { Home } from './Home'
import { HomeIcon } from './HomeIcon'
import { HourGlass } from './HourGlass'
import { Image } from './Image'
import { InfoIconOutline } from './InfoIconOutline'
import { Instagram } from './Instagram'
import { InValidUser } from './InValidUser'
import { KeyboardArrow } from './KeyboardArrow'
import { Lifetime } from './Lifetime'
import { Like } from './Like'
import { Liked } from './Liked'
import { Linkedin } from './Linkedin'
import { Location } from './Location'
import { Lock } from './Lock'
import { Logo } from './Logo'
import { Logout } from './Logout'
import { MedalIcon } from './MedalIcon'
import { MenuChatIcon } from './Menu'
import { MenuIcon } from './MenuIcon'
import { MenuLifetime } from './MenuLifetime'
import { MenuOpen } from './MenuOpen'
import { Message } from './Message'
import { MessageNoBg } from './MessageNoBg'
import { MessageNotify } from './MessageNotify'
import { MilitaryTech } from './MilitaryTech'
import { More } from './More'
import { MoreVertical } from './MoreVertical'
import { Navigation } from './Navigation'
import { NotFoundIcon } from './NotFound'
import { Notification } from './Notification'
import { PaddleIconFilledRounded } from './PaddleIconFilledRounded'
import { People } from './People'
import { PeopleOutline } from './PeopleOutline'
import { Person } from './Person'
import { PersonAdd } from './PersonAdd'
import { PersonOutline } from './PersonOutline'
import { Phone } from './Phone'
import { Photo } from './Photo'
import { PhotoCamera } from './PhotoCamera'
import { PickleBall } from './PickleBall'
import { Plus } from './Plus'
import { Refuse } from './Refuse'
import { RemoveCircle } from './RemoveCircle'
import { RemoveCircleDisable } from './RemoveCircleDisable'
import { Repeat } from './Repeat'
import { ReportGmailerrorredIcon } from './ReportGmailerrorredIcon'
import { RoundedError } from './RoundedError'
import { Save } from './Save'
import { Search } from './Search'
import { SearchIcon } from './SearchIcon'
import { SearchNoBg } from './SearchNoBg'
import { SearchPerson } from './SearchPerson'
import { SearchPersonOutline } from './SearchPersonOutline'
import { Security } from './Security'
import { Send } from './Send'
import { Shape } from './Shape'
import { Share } from './Share'
import { ShopIcon } from './ShopIcon'
import { ShoppingCartIcon } from './ShoppingCartIcon'
import { StarIcon } from './StarIcon'
import { Success } from './Success'
import { Support } from './Support'
import { ThumbDown } from './ThumbDown'
import { ThumbUp } from './ThumbUp'
import { Translate } from './Translate'
import { TrophyCupIconFilled } from './TrophyCupIconFilled'
import { Twitter } from './Twitter'
import { Visibility } from './Visibility'
import { VisibilityOff } from './VisibilityOff'
import { SVGProps } from 'react'
import { UnionLogo } from './UnionLogo'
import { User } from './User'
import { UserAddIcon } from './UserAddIcon'
import { UserIconFilled } from './UserIconFilled'
import { Warning } from './Warning'
import { Youtube } from './Youtube'
import { ZoomInMapIcon } from './ZoomInMapIcon'
import { ZoomOutMap } from './ZoomOutMap'
import { SettingsGear } from './SettingsGear'
import { ErrorIcon } from './Error'

export const ICONS = {
  Accept,
  AddCircle,
  AddPerson,
  ArrowBack,
  ArrowBackIcon,
  ArrowBackNoBg,
  ArrowDropdown,
  ArrowForward,
  ArrowLeft,
  ArrowRightLine,
  ArrowUp,
  AutoGraph,
  Bell,
  BlogIcon,
  Calendar,
  Cancel,
  CenterFocusStrong,
  ChatIcon,
  CheckAll,
  CheckCircle,
  Checkmark,
  ChevronLeft,
  ChevronRight,
  Clock,
  Close,
  Comment,
  CommentOutline,
  Copy,
  CropFree,
  DefaultAvatar,
  Delete,
  DownChevron,
  Edit,
  Email,
  EmailIcon,
  EmojiEvent,
  EmojiEventNotify,
  EmptyCircle,
  ErrorIcon,
  ErrorRoundedIcon,
  Event,
  EventOutline,
  EventsIconRounded,
  ExpandMore,
  Facebook,
  Favorite,
  FileDownload,
  FileUpload,
  Filter,
  FilterNoBg,
  Group,
  GroupOutline,
  Help,
  HelpOutline,
  Home,
  HomeIcon,
  HourGlass,
  Image,
  InValidUser,
  InfoIconOutline,
  Instagram,
  KeyboardArrow,
  Lifetime,
  Like,
  Liked,
  Linkedin,
  Location,
  Lock,
  Logo,
  Logout,
  MedalIcon,
  MenuChatIcon,
  MenuIcon,
  MenuLifetime,
  MenuOpen,
  Message,
  MessageNoBg,
  MessageNotify,
  MilitaryTech,
  More,
  MoreVertical,
  Navigation,
  NotFoundIcon,
  Notification,
  PaddleIconFilledRounded,
  People,
  PeopleOutline,
  Person,
  PersonAdd,
  PersonOutline,
  Phone,
  Photo,
  PhotoCamera,
  PickleBall,
  Plus,
  Refuse,
  RemoveCircle,
  RemoveCircleDisable,
  Repeat,
  ReportGmailerrorredIcon,
  RoundedError,
  Save,
  SettingsGear,
  Search,
  SearchIcon,
  SearchNoBg,
  SearchPerson,
  SearchPersonOutline,
  Security,
  Send,
  Shape,
  Share,
  ShopIcon,
  ShoppingCartIcon,
  StarIcon,
  Success,
  Support,
  ThumbDown,
  ThumbUp,
  Translate,
  TrophyCupIconFilled,
  Twitter,
  TwitterIcon,
  UnionLogo,
  User,
  UserAddIcon,
  UserIconFilled,
  Visibility,
  VisibilityOff,
  Warning,
  Youtube,
  ZoomInMapIcon,
  ZoomOutMap,
} as const

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string
  name: Icon
}

export type Icon = keyof typeof ICONS

export function Icon(iconProps: IconProps) {
  const RenderIcon = ICONS[iconProps.name]

  return <RenderIcon {...iconProps} />
}

export * from './Accept'
export * from './AddCircle'
export * from './AddPerson'
export * from './ArrowBack'
export * from './ArrowBackIcon'
export * from './ArrowBackNoBg'
export * from './ArrowDropdown'
export * from './ArrowForward'
export * from './ArrowForwardIcon'
export * from './ArrowLeft'
export * from './ArrowRightLine'
export * from './ArrowUp'
export * from './AutoGraph'
export * from './Bell'
export * from './BlogIcon'
export * from './Calendar'
export * from './Cancel'
export * from './CenterFocusStrong'
export * from './ChatIcon'
export * from './CheckAll'
export * from './CheckCircle'
export * from './Checkmark'
export * from './ChevronLeft'
export * from './ChevronRight'
export * from './Clock'
export * from './Close'
export * from './Comment'
export * from './CommentOutline'
export * from './Copy'
export * from './CropFree'
export * from './DefaultAvatar'
export * from './Delete'
export * from './DownChevron'
export * from './Edit'
export * from './Email'
export * from './EmailIcon'
export * from './EmojiEvent'
export * from './EmojiEventNotify'
export * from './EmptyCircle'
export * from './Error'
export * from './ErrorRoundedIcon'
export * from './Event'
export * from './EventOutline'
export * from './EventsIconRounded'
export * from './ExpandMore'
export * from './Facebook'
export * from './Favorite'
export * from './FileDownload'
export * from './FileUpload'
export * from './Filter'
export * from './FilterNoBg'
export * from './Gift'
export * from './Group'
export * from './GroupOutline'
export * from './HelpIcon'
export * from './HelpOutline'
export * from './Home'
export * from './HomeIcon'
export * from './HourGlass'
export * from './Image'
export * from './InValidUser'
export * from './InfoIconOutline'
export * from './Instagram'
export * from './KeyboardArrow'
export * from './Lifetime'
export * from './Like'
export * from './Liked'
export * from './Linkedin'
export * from './LocalOffer'
export * from './Location'
export * from './Lock'
export * from './Logo'
export * from './Logout'
export * from './MedalIcon'
export * from './Menu'
export * from './MenuIcon'
export * from './MenuLifetime'
export * from './MenuOpen'
export * from './Message'
export * from './MessageNoBg'
export * from './MessageNotify'
export * from './MilitaryTech'
export * from './More'
export * from './MoreVertical'
export * from './Navigation'
export * from './NotFound'
export * from './Notification'
export * from './PaddleIconFilledRounded'
export * from './People'
export * from './PeopleOutline'
export * from './Person'
export * from './PersonAdd'
export * from './PersonOutline'
export * from './Phone'
export * from './Photo'
export * from './PhotoCamera'
export * from './PickleBall'
export * from './Plus'
export * from './Refuse'
export * from './RemoveCircle'
export * from './RemoveCircleDisable'
export * from './Repeat'
export * from './ReportGmailerrorredIcon'
export * from './RoundedError'
export * from './Save'
export * from './SettingsGear'
export * from './Search'
export * from './SearchIcon'
export * from './SearchNoBg'
export * from './SearchPerson'
export * from './SearchPersonOutline'
export * from './Security'
export * from './Send'
export * from './Shape'
export * from './Share'
export * from './ShopIcon'
export * from './ShoppingCartIcon'
export * from './StarIcon'
export * from './Success'
export * from './Support'
export * from './ThumbDown'
export * from './ThumbUp'
export * from './Translate'
export * from './TrophyCupIconFilled'
export * from './Twitter'
export * from './TwitterIcon'
export * from './UnionLogo'
export * from './User'
export * from './UserAddIcon'
export * from './UserIconFilled'
export * from './Visibility'
export * from './VisibilityOff'
export * from './Warning'
export * from './Whatsapp'
export * from './Youtube'
export * from './ZoomInMapIcon'
export * from './ZoomOutMap'
